// App.tsx
import 'moment/locale/ru';
import moment from "moment";
import './Static/css/base.sass';
import SignIn from "Auth/SignIn";
import pprint from "./Utils/pprint";
import About from "Core/pages/About";
import './Static/css/wide-classes.css';
import Cabinet from "Cabinet/Cabinet";
import './Static/css/ReactToastify.sass';
import Head from "Core/components/Head";
import GuidePage from "Guide/GuidePage";
import GuidesPage from "Guide/GuidesPage";
import GuideOrder from "Guide/GuideOrder";
import TariffPage from "Tariff/TariffPage";
import CoursePage from "Course/CoursePage";
import TariffOrder from "Tariff/TariffOrder";
import CourseOrder from "Course/CourseOrder";
import CoursesPage from "Course/CoursesPage";
import SettingsTool from "Core/SettingsTool";
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer} from "react-toastify";
import ContractOffer from "Docs/ContractOffer";
import 'react-toastify/dist/ReactToastify.css';
import './Static/css/bootstrap_overwrite.sass';
import OrderTemplate from "Order/OrderTemplate";
import NewPassword from "Core/pages/NewPassword";
import smoothscroll from 'smoothscroll-polyfill';
import {HelmetProvider} from "react-helmet-async";
import React, {useContext, useEffect} from 'react';
import {ProfileProvider} from "User/ProfileContext";
import OAuthCallback from "Auth/Social/OAuthCallback";
import TariffGroupsPage from "Tariff/TariffGroupsPage";
import Psychologists from "Psychologist/Psychologists";
import store, {AppDispatch, RootState} from "Redux/store";
import {ThemeProvider, useTheme} from "Theme/ThemeContext";
import {ErrorProvider} from "Core/components/ErrorProvider";
import {Provider, useDispatch, useSelector} from "react-redux";
import {fetchPsychologyParams} from "Redux/psychologyParamsSlice";
import Questionnaire from "./Modules/Questionnaire/Questionnaire";
import Header, {headerHeight} from 'Core/components/Header/Header';
import {HeaderProvider} from "Core/components/Header/HeaderProvider";
import GiftCertificatePage from "GiftCertificate/GiftCertificatePage";
import PackageOrder from "./Modules/ConsultationPackage/PackageOrder";
import GiftCertificateOrder from "GiftCertificate/GiftCertificateOrder";
import GiftCertificatesPage from "GiftCertificate/GiftCertificatesPage";
import PsychologistDetailPage from "Psychologist/PsychologistDetailPage";
import {FavoritesProvider} from "Psychologist/Favorites/FavoritesContext";
import {AuthContext, AuthContextType, AuthProvider} from 'Auth/AuthContext';
import FavoritePsychologists from "Psychologist/Favorites/FavoritesPsychologists";
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom';
import TariffGroupDetailPage from "Tariff/TariffGroupDetailPage";

smoothscroll.polyfill();
const App: React.FC = () => {
    // Подключение Redux
    const dispatch = useDispatch<AppDispatch>();
    const {status} = useSelector((state: RootState) => state.psychologyParams);
    const isHeaderVisible = useSelector((state: RootState) => state.visibility.isHeaderVisible);
    const {plt} = useTheme();
    const {isAuthenticated} = useContext(AuthContext) as AuthContextType;

    const mainRef = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (status === 'idle' || status === 'failed') dispatch(fetchPsychologyParams());
    }, [status, dispatch, isAuthenticated]);

    useEffect(() => {
        moment.locale('ru');
    }, []);

    useEffect(() => {
        pprint('START')
    }, []);

    return (<>
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover
            theme={plt.mode}
            className={`disable-tap-select`}
        />
        <div className={'App h-100 fc disable-tap-select'}
             style={{color: plt.text.primary70, backgroundColor: plt.bg.primary}}>
            <div className="bg-image-wrapper">
                <img src="" className="bg-image" alt="Background"/>
            </div>
            <Head/>
            <Header/>
            <SettingsTool/>
            <main className={`overflow-y-auto no-scrollbar w-100`} ref={mainRef}
                  style={{
                      minHeight: isHeaderVisible ? `calc(100vh - ${headerHeight}px)` : '100vh',
                      maxHeight: isHeaderVisible ? `calc(100vh - ${headerHeight}px)` : '100vh',
                  }}>
                <Routes>
                    {/*<Route path="/" element={<Navigate to={'/auth'}/>}/>*/}

                    <Route path="/auth" element={<SignIn/>}/>
                    <Route path="/new-password" element={<NewPassword/>}/>
                    <Route path="oauth/:provider/callback/" element={<OAuthCallback/>}/>

                    {isAuthenticated === null ? '' : isAuthenticated ? '' : <>
                        <Route path="/questionnaire/*" element={<Questionnaire/>}/>

                        <Route path="/psychologists" element={<Psychologists containerRef={mainRef}/>}/>
                        <Route path="/psychologists/:id" element={<PsychologistDetailPage containerRef={mainRef}/>}/>
                        <Route path="/psychologists/favorites" element={<FavoritePsychologists/>}/>

                        <Route path="/courses" element={<CoursesPage cls={'mx-auto'}/>}/>
                        <Route path="/course/:productId" element={<CoursePage cls={'mx-auto'}/>}/>

                        <Route path="/guides" element={<GuidesPage cls={'mx-auto'}/>}/>
                        <Route path="/guide/:productId" element={<GuidePage cls={'mx-auto'}/>}/>

                        <Route path="/tariffs" element={<TariffGroupsPage cls={'mx-auto'}/>}/>
                        <Route path="/tariff/:productId" element={<TariffPage cls={'mx-auto'}/>}/>
                        <Route path='/tariff-groups/:id' element={<TariffGroupDetailPage/>}></Route>

                        <Route path="/gift-certificates"
                               element={<GiftCertificatesPage cls={'mx-auto'}/>}/>
                        <Route path="/gift-certificate/:productId"
                               element={<GiftCertificatePage cls={'mx-auto'}/>}/>

                        <Route path="/order" element={<OrderTemplate/>}>
                            <Route path="package" element={<PackageOrder/>}/>
                            <Route path="tariff/:productId" element={<TariffOrder/>}/>
                            <Route path="course/:productId" element={<CourseOrder/>}/>
                            <Route path="guide/:productId" element={<GuideOrder/>}/>
                            <Route path="gift-certificate/:productId" element={<GiftCertificateOrder/>}/>
                            <Route index element={<Navigate to="package" replace/>}/>
                        </Route>
                    </>}

                    <Route path="/about" element={<About/>}/>
                    <Route path="/contract-offer" element={<ContractOffer/>}/>

                    <Route path="/*" element={<Cabinet/>}/>
                </Routes>
                {/*)}*/}
            </main>
        </div>
    </>)
        ;
}

const RootApp: React.FC = () => (
    <Provider store={store}>
        <Router>
            <HeaderProvider>
                <AuthProvider>
                    <ProfileProvider>
                        <ErrorProvider>
                            <ThemeProvider>
                                <FavoritesProvider>
                                    <HelmetProvider>
                                        <App/>
                                    </HelmetProvider>
                                </FavoritesProvider>
                            </ThemeProvider>
                        </ErrorProvider>
                    </ProfileProvider>
                </AuthProvider>
            </HeaderProvider>
        </Router>
    </Provider>
);

export default RootApp;
